import React from 'react';
import { SectionWrapper, CTAButton } from './Shared';
import { Lock, Zap, Tag } from 'lucide-react';
import { ViewersCounter } from './ViewersCounter';
export const OfferSection = () => {
  return <SectionWrapper id="oferta" className="relative overflow-hidden" data-id="element-138">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-gold-500/5 blur-[120px] rounded-full z-0 pointer-events-none" data-id="element-139"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-140">
        <div className="bg-dark-800 border border-gold-500/30 rounded-3xl p-8 md:p-12 lg:p-16 text-center shadow-[0_0_50px_rgba(212,165,116,0.1)]" data-id="element-141">
          {/* Launch badge */}
          <div className="flex justify-center mb-8" data-id="element-142">
            <div className="inline-flex items-center gap-2 bg-red-500/10 border border-red-500/30 text-red-400 font-oswald font-bold tracking-widest uppercase text-xs md:text-sm py-2 px-6 rounded-full animate-pulse" data-id="element-143">
              <Tag className="w-4 h-4" data-id="element-144" />
              Precio Especial de Lanzamiento
            </div>
          </div>

          <div className="max-w-3xl mx-auto mb-10" data-id="element-145">
            <h2 className="font-oswald text-3xl md:text-4xl font-bold text-white uppercase mb-6" data-id="element-146">
              Recuperar tu vitalidad no tiene por qué costar una fortuna en
              clínicas privadas.
            </h2>
            <p className="text-xl text-zinc-300" data-id="element-147">
              Puedes resetear tu sistema hoy mismo por una fracción de lo que
              cuesta una cena fuera de casa.
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16 mb-12" data-id="element-148">
            <img src="https://cdn.magicpatterns.com/uploads/9h8seUYueD9nPUJzA8E2d7/portada_hombre_apagado_nunca_mas.png" alt="Protocolo Hombre Apagado No Más" className="w-full max-w-[250px] drop-shadow-2xl" data-id="element-149" />

            <div className="text-center md:text-left" data-id="element-150">
              <div className="text-gold-500 font-oswald font-bold tracking-widest uppercase text-sm mb-4" data-id="element-151">
                Acceso Inmediato al Protocolo Completo
              </div>

              {/* Original price crossed out */}
              <div className="flex flex-col items-center md:items-start mb-2" data-id="element-152">
                <span className="text-zinc-500 text-xl line-through font-oswald" data-id="element-153">
                  $57.000 COP / $13.50 USD
                </span>
              </div>

              {/* Discount price */}
              <div className="flex flex-col items-center md:items-start mb-2" data-id="element-154">
                <span className="font-oswald text-5xl md:text-6xl font-bold text-white" data-id="element-155">
                  $27.000 <span className="text-2xl text-zinc-500" data-id="element-156">COP</span>
                </span>
                <span className="text-zinc-400 text-lg mt-1" data-id="element-157">/ $6.36 USD</span>
              </div>

              {/* Savings badge */}
              <div className="inline-flex items-center gap-1.5 bg-green-500/10 border border-green-500/30 text-green-400 text-sm font-bold py-1.5 px-4 rounded-full mb-6" data-id="element-158">
                Ahorras más del 50%
              </div>

              <div className="mb-4 flex justify-center md:justify-start" data-id="element-159">
                <ViewersCounter data-id="element-160" />
              </div>

              <div data-id="element-161">
                <CTAButton className="w-full md:w-auto text-center justify-center mb-6" data-id="element-162">
                  ¡Quiero volver a encenderme!
                </CTAButton>
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center md:justify-start gap-4 text-sm text-zinc-400" data-id="element-163">
                <div className="flex items-center gap-2" data-id="element-164">
                  <Lock className="w-4 h-4 text-green-500" data-id="element-165" />
                  <span data-id="element-166">Pago seguro y encriptado</span>
                </div>
                <div className="hidden sm:block w-1 h-1 rounded-full bg-zinc-600" data-id="element-167"></div>
                <div className="flex items-center gap-2" data-id="element-168">
                  <Zap className="w-4 h-4 text-gold-500" data-id="element-169" />
                  <span data-id="element-170">Acceso instantáneo al correo</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SectionWrapper>;
};